import { render, staticRenderFns } from "./WorkspaceForEvents.vue?vue&type=template&id=1423b9e3&scoped=true&"
import script from "./WorkspaceForEvents.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceForEvents.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceForEvents.vue?vue&type=style&index=0&id=1423b9e3&scoped=true&lang=scss&"
import style1 from "./WorkspaceForEvents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423b9e3",
  null
  
)

export default component.exports